import { createFileRoute } from '@tanstack/react-router';
import { requireEnterpriseAdmin } from '@/features/enterprise/enterprise-api';
import { MembershipsPage } from '@/features/membership/list-page';

export const Route = createFileRoute('/_authenticated/operations/memberships')({
  beforeLoad: ({ context, location }) =>
    requireEnterpriseAdmin(context.queryClient, location.href),
  validateSearch: (search: Record<string, unknown>): { keyword?: string } => ({
    keyword: typeof search.keyword === 'string' ? search.keyword : undefined,
  }),
  component: () => <MembershipsPage keyword={Route.useSearch().keyword} />,
});
